import React, {useEffect, useState} from "react";
import HistoryLog from "./HistoryLog";
import RestClient from "../../../../integration/RestClient";
import {BDOperation, EntityType} from "../../../../integrated-client";
import LoadingBlock from "../../../../components/LoadingBlock/LoadingBlock";
import styles from './HistoryLog.module.css';

interface IHistoryProps {
  id: string,
  type?: EntityType;
}

const HistoryLayout: React.FC<IHistoryProps> = (props) => {
  const {id, type} = props
  const [historyData, setHistoryData] = useState<Array<BDOperation>>([])
  const [showLoading, setShowLoading] = useState(false)
  const [errMessage, setErrMessage] = useState('')

  useEffect(() => {
    setShowLoading(true);
    RestClient.history.updateHistoryHistoryGet({id, type})
      .then((data: Array<BDOperation>) => {
        setShowLoading(false);
        setHistoryData(data);
      })
      .catch(() => {
        setShowLoading(false)
        setErrMessage('There is no history for this item')
      })
  }, [])

  return (
    <>
      {showLoading && <LoadingBlock/>}
      {!showLoading && errMessage === '' && historyData.length && historyData.map((actionHistoryData: BDOperation, index) => {
        return <>
          <HistoryLog
            actionHistoryData={actionHistoryData}
          />
          { index !== historyData.length - 1 && <hr className={styles.hrDouble}/>}
        </>
      })
      }
      {errMessage !== '' &&
      <div>
        {errMessage}
      </div>}
    </>
  )
}

export default HistoryLayout
